import axios, { AxiosError } from "axios";

const NodeaxiosInstance = axios.create({
    // baseURL: 'http://192.168.0.100:5005/api/',
    // baseURL: 'http://192.168.1.2:5004/api/',


    // test
    // baseURL: 'https://user-api2-test.pingle.in/api/'

    // production
    baseURL: 'https://user-api-v2.pingle.in/api/'
});

NodeaxiosInstance.interceptors.request.use(
    async (config) => {
        const user = JSON.parse(localStorage.getItem("user"));
        const paramtoken = user?.token;
        if (paramtoken) {
            if (config.headers)
                (config.headers).set("Authorization", `${paramtoken}`);
        }
        return config;
    },
    (error) => Promise.reject(error),
);

NodeaxiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error instanceof AxiosError && error.response?.status == 401) {
            // useAuthStore.setState({ signedInAs: undefined });
        }
        return Promise.reject(error);
    },
);

export default NodeaxiosInstance;


